import React, { useEffect, useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import TabsComponent from "./TabsComponent";
import DashboardWrapper from "../../components/DashboardWrapper";

const Settings = () => {
  const theme = useTheme();
  const mdScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [collapse, setCollapse] = useState(false);

  useEffect(() => {
    setCollapse(mdScreen);
  }, [mdScreen]);

  return (
    <DashboardWrapper>
      <TabsComponent collapse={collapse} />
    </DashboardWrapper>
  );
};

export default Settings;
